
<script setup>

  import AudioPlayer from '../components/audio-player.vue';

  import audio from '../audio/elaine-*.mp3';

  import track from '../audio/elaine-*.vtt';

  const players = [ {

    id: 1,

    title: 'Summertime Visits',

    source: 'Source: Interview with Elaine Taylor Blakey, August 10, 2007. Original audio unavailable; this oral history was re-recorded by voiceover artists.'

  }, {

    id: 2,

    title: 'Telling the Whole Story',

    source: 'Source: NY-VA Club Group Interview, Part of the Lewis Mountain Cultural Landscape Report, August 30, 2022.'

  }, {

    id: 3,

    title: 'Tell Your Story with Pride',

    source: 'Source: NY-VA Club Group Interview, Part of the Lewis Mountain Cultural Landscape Report, August 30, 2022.'

  }, {

    id: 4,

    title: 'The Lodge Was a Special Place',

    source: 'Source: NY-VA Club Group Interview, Part of the Lewis Mountain Cultural Landscape Report, August 30, 2022.'
  }, {

    id: 5,

    title: 'Best Food Along the Entire Skyline Drive',

    source: 'Source: Interview with Elaine Taylor Blakey, 2022.'

  }, {

    id: 6,

    title: 'We Played Simple Games',

    source: 'Source: Interview with Elaine Taylor Blakey, 2022.'

  }, {

    id: 7,

    title: 'Be Proud, Hold Your Head High',

    source: 'Source: Interview with Elaine Taylor Blakey, 2022.'

  } ].map( obj => ( { ...obj, audio: audio[ obj.id ], track: track[ obj.id ] } ) );

</script>

<template>

  <p>Summertime Visitor</p>

  <div v-for="{ audio, track, title, source } in players" class="mt-6" >

    <h4 class="font-bold">{{ title }}</h4>

    <AudioPlayer class="mt-4" :src="audio" :track="track" />

    <div class="mt-4 text-xs italic">{{ source }}</div>

  </div>

</template>
